import { useEffect, useState } from 'react';
import { useGlobalModalContext } from '../../components/GlobalModal';
import { MODAL_TYPES } from '../../components/GlobalModal/GlobalModal';
import { useFetchArticle } from './index';
import { AccessStatus } from '../../services/dtos/article/article.dto';

interface ConfirmedQuotaCall {
  articleId: number;
  callback: () => void;
}

export type CheckArticleAccessStatus = (articleId: number, confirmViewArticleCallback: () => void) => void;

export default (): CheckArticleAccessStatus => {
  const [confirmedQuotaCall, setConfirmedQuotaCall] = useState<ConfirmedQuotaCall | null>(null);
  const {
    data: article,
    isLoading,
    isRefetching,
  } = useFetchArticle(confirmedQuotaCall?.articleId || null, false, false);
  const { showModal, closeModal } = useGlobalModalContext();

  useEffect(() => {
    if (!confirmedQuotaCall || isLoading || isRefetching) {
      return;
    }
    const { callback } = confirmedQuotaCall;

    if (article && article.accessStatus !== AccessStatus.granted) {
      showModal(MODAL_TYPES.RESTRICTED_ARTICLE_CONTENT, {
        onConfirm: () => {
          closeModal();
          callback();
        },
        articlePermissions: article,
      });
    } else {
      callback();
    }
    setConfirmedQuotaCall(null);
  }, [confirmedQuotaCall, isLoading, isRefetching]);

  return (id: number, confirmViewArticleCallback: () => void) => {
    setConfirmedQuotaCall({ articleId: id, callback: confirmViewArticleCallback });
  };
};
